import RedirectToQuestions from '@ms/yammer-web-components/dist/questions/RedirectToQuestions';
import RedirectToFeed from '@ms/yammer-web-components/dist/route/RedirectToFeed';
import { useIsQuestionsOnlyMode } from '@ms/yammer-web-ui-features/dist/featureChecks';
import { uiFeatureAccessSymbol, useUIFeatures } from '@ms/yammer-web-ui-features/dist/features';
import React, { FC } from 'react';

const PageRoot: FC = () => {
  const isHomePageFeedEnabled = useUIFeatures(({ homeFeedPage }) => homeFeedPage?.[uiFeatureAccessSymbol] === true);
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();

  if (isQuestionsOnlyMode) {
    return <RedirectToQuestions />;
  }

  if (isHomePageFeedEnabled) {
    return <RedirectToFeed />;
  }

  return null;
};

export default PageRoot;
